import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=luxury%20grand%20lisboa%20hotel%20macau%20iconic%20golden%20lotus%20shaped%20skyscraper%20at%20sunset%20dramatic%20sky%20warm%20golden%20hour%20lighting%20luxurious%20exterior%20architecture%20palm%20trees%20elegant%20entrance%20premium%20travel%20destination%20atmospheric%20cinematic%20photography&width=1920&height=1080&seq=grand-lisboa-hero-01&orientation=landscape"
        alt="新葡京酒店外观 - 澳门地标豪华酒店"
        title="新葡京酒店 - 澳门地标豪华酒店"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-12 h-px bg-primary-400/60"></span>
          <span className="text-primary-300 text-xs md:text-sm tracking-[0.2em] uppercase font-medium">
            Grand Lisboa Hotel Macau
          </span>
          <span className="w-12 h-px bg-primary-400/60"></span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 leading-tight max-w-3xl">
          澳门地标 · 极致奢华
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          新葡京酒店 — 集顶级客房、米其林星级餐厅与世界级娱乐于一体<br className="hidden md:block" />
          为您缔造难忘的澳门之旅
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <button
            onClick={() => navigate('/category/rooms')}
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            查看房型与价格
          </button>
          <button
            onClick={() => navigate('/about')}
            className="px-8 py-3 border border-background-300/40 text-background-50 font-medium rounded-lg hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            了解更多
          </button>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-3 gap-6 md:gap-12">
          {[
            { value: '430+', label: '豪华客房' },
            { value: '6星', label: '米其林星级' },
            { value: '2007', label: '开业年份' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-primary-300">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300/80 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-300/40 rounded-full flex items-start justify-center pt-2">
          <div className="w-1 h-2 bg-background-300/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}